module.exports = __webpack_public_path__ + "static/media/ZEFI-BUSD.1794a581.svg";